/* KUTEE' mobile sticky buy bar.
   Reveals the bottom Add-to-bag bar once the main button has scrolled out of
   view (above the viewport). The bar is display:none on desktop via CSS, so
   this is effectively mobile-only. Re-inits on Theme Editor section load. */
(() => {
  const init = () => {
    // Disconnect a prior observer so Theme Editor section reloads don't leak
    // multiple observers all toggling the same bar.
    if (window.__kuStickyObserver) window.__kuStickyObserver.disconnect();

    const buybar = document.querySelector('[data-ku-buybar]');
    if (!buybar) return;

    // Waitlist mode has no .ku-product__add — observe the waitlist block instead.
    const mainBtn = document.querySelector('.ku-product__add, [data-ku-waitlist]');
    if (!mainBtn || !('IntersectionObserver' in window)) return;

    // Buybar waitlist link: open the <details> so the email field is visible
    // when the anchor jump lands on it.
    const buybarWaitlist = document.querySelector('[data-ku-buybar-waitlist]');
    if (buybarWaitlist) {
      buybarWaitlist.addEventListener('click', () => {
        const details = document.querySelector('.ku-waitlist__details');
        if (details) details.open = true;
      });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Show only once the main button has scrolled ABOVE the viewport.
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          buybar.classList.toggle('is-visible', scrolledPast);
        });
      },
      { threshold: 0 }
    );

    observer.observe(mainBtn);
    window.__kuStickyObserver = observer;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
